import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import CaptchaToGenerateEditService from 'app/admin/captchatogenerate/service/CaptchaToGenerateEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import CaptchaTypeEditService from '../../captchatype/service/CaptchaTypeEditService';

const config = {
	key: 'captchaToGenerateEditForm',
	text: 'Captcha To Generate',
	textKey: 'captchaToGenerate',
	service: CaptchaToGenerateEditService,
	icon: 'person',
	fields: [
		{
			key: 'count',
			text: 'Count',
			textKey: 'count',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'captchaType',
			text: 'Captcha Type',
			textKey: 'captchaType',
			component: EditFormSelectField,
			required: true,
			items: () => CaptchaTypeEditService.getCaptchaTypeSelection()
		}
	]
};

function CaptchaToGenerateEditForm() {
	return <EditFormPage config={config} />;
}

export default CaptchaToGenerateEditForm;
